import { render, staticRenderFns } from "./SelfUpload.vue?vue&type=template&id=2c36cc9f&scoped=true&"
import script from "./SelfUpload.vue?vue&type=script&lang=js&"
export * from "./SelfUpload.vue?vue&type=script&lang=js&"
import style0 from "./SelfUpload.vue?vue&type=style&index=0&id=2c36cc9f&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c36cc9f",
  null
  
)

export default component.exports